import { DownArrowIcon } from '../Icons';

const PageControls = ({ canPageUp, onPageUp, canPageDown, onPageDown, disabled }) => {
  return (
    <nav className="page-controls">
      <button
        className="page-controls__btn page-controls__btn--up"
        disabled={disabled || !canPageUp}
        onClick={onPageUp}
      >
        <DownArrowIcon />
      </button>
      <button
        className="page-controls__btn page-controls__btn--down"
        disabled={disabled || !canPageDown}
        onClick={onPageDown}
      >
        <DownArrowIcon />
      </button>
    </nav>
  );
};

export default PageControls;
